import React from 'react';

export default function Header() {
  return (
    <div className='quizapp_header'>
      <h1>QuizApp</h1>
      <p>Select an option and reveal the answers when you're ready</p>
    </div>
  )
}
